// Firestore hands `updatedAt` back as a Timestamp before conversion and a Date after it.
export const toMillis = (value: unknown): number | null => {
  if (value instanceof Date) {
    return value.getTime();
  }
  const maybeTimestamp = value as { toDate?: () => Date } | null | undefined;
  if (maybeTimestamp && typeof maybeTimestamp.toDate === 'function') {
    return maybeTimestamp.toDate().getTime();
  }
  return null;
};
